// src/components/Footer.js
import React from 'react';
import './Footer.css';
import { resetConsent } from '../../utils/cookieConsent';

function Footer() {
  return (
    <div className="footer">
      {/* Left Side: ZEAL and Address Info */}
      <div className="left-container">
        <div className="zeal-address-container">
          <div className="text-wrapper">
            ZE<br />AL
          </div>
          <div className="address-info">
            <p className="text-i">Jana Sobieskiego 20</p>
            <p className="text-i">Kraków, 31-136</p>
            <p className="text-i">contact@zealfc.com</p>
            <p className="text-i">+48 451 633 711</p>
          </div>
        </div>
      </div>

      {/* Right Side: Social Media Links */}
      <div className="right-container">
        <p className="span-wrapper">Facebook</p>
        <p className="span-wrapper">Instagram</p>
        <a
          className="span-wrapper footer-social-link"
          href="https://chat.whatsapp.com/LMU3XnYLb0AJlzJa3DOYww?mode=gi_t"
          target="_blank"
          rel="noopener noreferrer"
        >
          WhatsApp
        </a>
        <button
          type="button"
          className="span-wrapper footer-link-button"
          onClick={() => {
            resetConsent();
            window.location.reload();
          }}
        >
          Cookie settings
        </button>
      </div>
    </div>
  );
}

export default Footer;
